package diana.soleil.design.iraniancanadienbazzar.core.model

/**
 * An owner's request to change the identity fields of an APPROVED listing — name, category or
 * address — which only go live after an admin approves them (owner rule 2026-09-14: a new owner must
 * not be able to silently rename or relocate a listing). Everything else an owner edits directly.
 *
 * `current*` is the listing as it was when the owner asked, so the admin sees old → new side by side
 * even if the listing changes again before review. A null `proposed*` means "leave unchanged".
 */
data class ListingChangeRequest(
    val id: String,
    val businessId: String,
    val businessName: String,
    val requestedBy: String,
    val proposedName: String? = null,
    val proposedCategoryId: String? = null,
    val proposedAddress: Address? = null,
    val currentName: String = "",
    val currentCategoryId: String = "",
    val currentAddress: Address? = null,
    val status: ChangeRequestStatus = ChangeRequestStatus.Pending,
    val rejectionReason: String? = null,
    val createdAtMillis: Long? = null,
)

/** Review state of a [ListingChangeRequest]; wire values are the lowercase names. */
enum class ChangeRequestStatus { Pending, Approved, Rejected }

/**
 * The listing fields an owner saves directly (no admin gate). Localized text carries all three
 * languages — the editor changes the one the owner is typing in and keeps the others as they were.
 */
data class ListingDetailsEdit(
    val serviceTitle: LocalizedText,
    val description: LocalizedText,
    val phone: String?,
    val email: String?,
    val website: String?,
    /** `mon`…`sun` → free-text hours ("9:00–17:00", "Closed"); blank days are dropped. */
    val hours: Map<String, String>,
    val languagesSpoken: List<String>,
    val priceLevel: Int?,
    val offersChat: Boolean,
    val offersOrdering: Boolean,
)
